module.exports = __webpack_public_path__ + "media/src/application/media/help_1-e0668cc4f715086cb559104bf1bfd2e5.jpg";